<template>
  <div>
    <div class="clearfix">
      <div class="float-right">
        <em class="text-info" v-text="`Page: ${pagination.page}`" />
        <b-form-select
          class="w-auto ml-2"
          variant="primary"
          v-model="pagination.limit"
          :options="pagination.pageOptions"
          @change="setPage(1)"
        ></b-form-select>
        <b-button-group>
          <b-button
            variant="primary"
            class="mr-1"
            v-text="'<<'"
            :disabled="fetching_members || pagination.page == 1"
            @click="setPage(1)"
          />
          <b-button
            variant="primary"
            class="mr-1"
            v-text="'<'"
            :disabled="fetching_members || pagination.page == 1"
            @click="previousPage()"
          />
          <b-button
            variant="primary"
            class="mr-1"
            v-text="'>'"
            :disabled="
              fetching_members || (items && items.length < pagination.limit)
            "
            @click="nextPage()"
          />
        </b-button-group>
      </div>
    </div>
    <b-table
      striped
      hover
      bordered
      show-empty
      fixed
      thead-class="table-primary"
      :items="items"
      :fields="fields"
      class="mt-2"
      :busy="fetching_members"
    >
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>{{ $t("commons.loading") }}</strong>
        </div>
      </template>
      <template v-slot:cell(actions)="row">
        <a
          :href="$routes('program.persons.edit', {id: row.item.personId})"
          target="_blank"
          >{{row.item.personId}}</a>
      </template>
    </b-table>
  </div>
</template>
<script>
import MembersApi from '../../../apis/MembersApi';

export default {
  props: {
    permissions: Object | Array,
    campaignId: String,
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fetching_members: false,
      items: [],
      instanceId: window.Laravel.selected_instance
          ? window.Laravel.selected_instance.id
          : null,
      pagination: {
        page: 1,
        limit: 10,
        pageOptions: [10, 25, 50, 100],
      },
      fields: [
        {
          key: "actions",
          label: this.$t("scheduler.person_id"),
          thStyle: { width: "20%" },
        },
        {
          key: "attributes.status",
          label: this.$t("scheduler.status")
        },
        {
          key: "createTime",
          label: this.$t("commons.created_time"),
          formatter: (value) => {
            return this.$options.filters.datetime(value);
          },
        },
        {
          key: "attributes.executeAt",
          label: this.$t("scheduler.executed_at"),
          formatter: (value) => {
            return this.$options.filters.datetime(value);
          },
        },
        {
          key: "lastModifiedTime",
          label: this.$t("commons.last_modified"),
          formatter: (value) => {
            return this.$options.filters.datetime(value);
          },
        },
      ],
    }
  },
  methods: {
    fetchMembers() {
      this.fetching_members = true;
      const params = {
        limit: this.pagination.limit,
        offset: (this.pagination.page - 1) * this.pagination.limit,
      };

      MembersApi.all(params, this.instanceId, this.campaignId)
        .then(r => {
          this.fetching_members = false;
          this.items = r.result;
        })
        .catch(e => {
          this.fetching_members = false;
          this.errorMessage = this.$t("scheduler.unable_to_search_members");
          if (e.response && e.response.status == 400) {
            this.errorMessage = e.response.data.data.detail;
          }
          this.$toast.error("Error", this.errorMessage);
        });
    },
    nextPage() {
      this.setPage(this.pagination.page + 1);
    },
    previousPage() {
      this.setPage(this.pagination.page - 1);
    },
    setPage(page) {
      this.pagination.page = page;
      this.fetchMembers();
    },
  },
  created() {
    this.fetchMembers();
  }
}
</script>
